
export {default as PageLogin} from './_Login'
export {default as ResetPassword} from './_ResetPassword';



// WEBPACK FOOTER //
// ./src/PageLogin/index.js